import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DateRangeFilter } from './DateRangeFilter';
import { FaCaretUp, FaCaretDown, FaSort } from '../util/reactIcons';
import { ClearButton, InputContainer, InputField } from './styled/StyledFiltersRow';
import { PacsSelector } from './PacsSelector';
import capitalizeFirst from '../util/string';

const FiltersRow = ({ onSort, filters, filtersPerRow, onValueChange, sortFieldName, sortDirection, dateProps }) => {
  const { t } = useTranslation();
  const tr = (string) => capitalizeFirst(t(string.toLowerCase()));

  const studySearchConfig = useSelector((state) => state.manager.studySearchConfig);
  const studySearchFilters = studySearchConfig && studySearchConfig.searchFilters ? studySearchConfig.searchFilters : [];

  const sortIcons = [FaSort, FaCaretUp, FaCaretDown];
  const sortIconForSortField = sortDirection === 'asc' ? sortIcons[1] : sortIcons[2];

  const createFilterCell = (filter, i) => {
    const { dicomStandardTagId, qidoQueryStringParam, label: filterLabel } = filter;
    const isSortField = sortFieldName === qidoQueryStringParam;
    const SortIcon = isSortField ? sortIconForSortField : sortIcons[0];
    let inputValue = filters[qidoQueryStringParam] || '';

    const clear = () => onValueChange(qidoQueryStringParam, '');
    const submit = (e) => onValueChange(qidoQueryStringParam, e.target.value)

    return (
      <div key={`${qidoQueryStringParam}-${i}`} className="StudiesTable_Filters_Row_Cell">
        <label
          htmlFor={`filter-${qidoQueryStringParam}`}
          onClick={() => onSort(qidoQueryStringParam)}
        >
          {tr(filterLabel)}
          <span> </span>
          {SortIcon && <SortIcon style={{ fontSize: '15px', marginLeft: '5px' }} />}
        </label>
        <InputContainer>
          <InputField
            type="text"
            id={`filter-${qidoQueryStringParam}`}
            value={inputValue}
            onChange={submit}
          />
          {inputValue && (
            <ClearButton onClick={clear}>x</ClearButton>
          )}
        </InputContainer>
      </div>
    );
  };

  const PacsSelectorFilter = () => (
    <>
      <div key="StudyDate" className="StudiesTable_Filters_Row_Cell" />
      <div key="PacsSelector" className="StudiesTable_Filters_Row_Cell">
        <PacsSelector />
      </div>
    </>
  );

  const defaultFields = [];
  const numOfRows = Math.ceil(studySearchFilters.length / filtersPerRow);

  for (let currentRowIndex = 0; currentRowIndex < numOfRows; currentRowIndex++) {
    const cells = [];

    for (let currentCellIndex = 0; currentCellIndex < filtersPerRow; currentCellIndex++) {
      const filterIndex = (filtersPerRow * currentRowIndex) + currentCellIndex;
      if (filterIndex === studySearchFilters.length) break;

      const filterCell = createFilterCell(studySearchFilters[filterIndex], filterIndex);
      cells.push(filterCell);
    }

    defaultFields.push(
      <div key={currentRowIndex} className="StudiesTable_Filters_Row_SubRow">
        {cells}
      </div>
    );
  }

  // Add a generic StudyDate filter. Add Pacs selector if configured
  defaultFields.push(
    <div key="DateField" className="StudiesTable_Filters_Row_SubRow">
      <DateRangeFilter
        dateProps={dateProps}
        onValueChange={onValueChange}
      />
      <PacsSelectorFilter />
    </div>
  );

  return [defaultFields];
};

export { FiltersRow };
export default FiltersRow;
